import type { AFSDV01HistoryPoint } from './types';

/**
 * Merge append-only AFS DV01 snapshots by scenario date. Later inputs win,
 * making full hydration and same-period socket retries idempotent while
 * preserving an oldest-first chart contract.
 */
export const mergeAFSDV01History = (
  ...histories: Array<AFSDV01HistoryPoint[] | null | undefined>
): AFSDV01HistoryPoint[] => {
  const byScenarioDate = new Map<string, AFSDV01HistoryPoint>();
  histories.forEach(history => {
    history?.forEach(point => {
      if (point?.scenario_date) byScenarioDate.set(point.scenario_date, point);
    });
  });
  return Array.from(byScenarioDate.values()).sort((a, b) =>
    a.scenario_date.localeCompare(b.scenario_date),
  );
};
